<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <CalculatorHeading :step="step"></CalculatorHeading>
      <SelectMultipleInput
        :question="$t('access-control.question')"
        :image="require('@/assets/access-control.jpeg')"
        :selections="selections"
        :clicked-callback="onSelect"
        :next="next"
      ></SelectMultipleInput>
      <a
        @click="$router.push(getPrevStepUrl(step, $i18n.locale))"
        class="back-btn"
        >{{ $t("back") }}</a
      >
    </div>
  </div>
</template>

<script>
  import {mapMutations} from "vuex";
  import CalculatorHeading from "../../components/CalculatorHeading";
  import {getStepIndex} from "@/utils/steps.js";
  import {getPrevStepUrl, goToNextStep, redirectToUnselectedStepIfAny} from "../../utils/steps";
  import SelectMultipleInput from "../../components/SelectMultipleInput";

  export default {
  name: "AccessControl",
  components: { SelectMultipleInput, CalculatorHeading },
  data() {
    return {
      step: getStepIndex("access-control"),
      getPrevStepUrl: getPrevStepUrl,
      selections: [
        {
          name: this.$t("access-control.intercom"),
          selected: this.$store.state.data.intercom,
          update: value => this.updateIntercom(value)
        },
        {
          name: this.$t("access-control.front-doors"),
          selected: this.$store.state.data.frontDoors,
          update: value => this.updateFrontDoors(value)
        },
        {
          name: this.$t("access-control.garage"),
          selected: this.$store.state.data.garageDoors,
          update: value => this.updateGarageDoors(value)
        },
        {
          name: this.$t("access-control.gates"),
          selected: this.$store.state.data.propertyFence,
          update: value => this.updatePropertyFence(value)
        }
      ]
    };
  },
  mounted() {
    redirectToUnselectedStepIfAny(
      this.step,
      this.$store.state.data,
      this.$router,
      this.$i18n.locale
    );
  },
  methods: {
    ...mapMutations([
      "updateIntercom",
      "updateFrontDoors",
      "updateGarageDoors",
      "updatePropertyFence"
    ]),
    onSelect(selection) {
      selection.update(!selection.selected);
      selection.selected = !selection.selected;
    },
    next() {
      goToNextStep(this.step, this.$i18n.locale, this.$router);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../common/_variables.scss";
h4 {
  color: $color-primary;
}
.back-btn {
  margin-top: 60px;
}
</style>
